import { useEffect, useState } from "react";
import { useLang } from "./OneHealthContext";
import { setRuntimeDeviceKey, clearRuntimeDeviceKey, deleteRosterCache } from "./roster";
import FaceScan from "./steps/FaceScan";
import Pulmo from "./steps/Pulmo";
import Pvtb from "./steps/Pvtb";
import Result from "./steps/Result";

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "bn", label: "বাংলা" },
  { code: "ta", label: "தமிழ்" },
];

function LanguageGate({ onSelect, onRegister }) {
  const { tr } = useLang();
  return (
    <div className="oh-view oh-site-gate">
      <div className="oh-site-mark" aria-hidden="true"><i /><i /><i /></div>
      <div className="oh-kicker">CarePlix OneHealth</div>
      <h1 className="oh-h1">Choose your language</h1>
      <p className="oh-sub">Select one option to begin your workplace safety check.</p>
      <div className="oh-language-grid">
        {LANGUAGES.map((language) => (
          <button type="button" className="oh-language-choice" key={language.code} onClick={() => onSelect(language.code)}>
            <span>{language.label}</span>
            <b aria-hidden="true">→</b>
          </button>
        ))}
      </div>
      <button type="button" className="oh-btn ghost oh-site-register" onClick={onRegister}>
        {tr("identify.registerButton")}
      </button>
      <div className="oh-spacer" />
      <p className="oh-foot">A safe start for every shift</p>
    </div>
  );
}

export default function SiteJourney({ deviceId }) {
  const { setLang } = useLang();
  const [step, setStep] = useState("language");
  const [result, setResult] = useState(null);
  const [pulmoResult, setPulmoResult] = useState(null);
  const [pvtResult, setPvtResult] = useState(null);
  const [scanToken, setScanToken] = useState(null);

  useEffect(() => {
    setRuntimeDeviceKey(deviceId);
    // Remove any roster left by an older version of the phone journey. The
    // online route never repopulates it; only the normal kiosk uses IndexedDB.
    deleteRosterCache().catch(() => {});
    return clearRuntimeDeviceKey;
  }, [deviceId]);

  const restart = () => {
    setResult(null);
    setPulmoResult(null);
    setPvtResult(null);
    setScanToken(null);
    setStep("language");
  };

  if (step === "language") return <LanguageGate onSelect={(code) => {
    setLang(code);
    setStep("facescan");
  }} onRegister={() => setStep("registration")} />;
  if (step === "registration") {
    return <FaceScan onlineIdentity startInRegistration scanDuration={30}
      forceAssessments={{ pulmo: true, cognitive: true }}
      onDone={(payload, options) => { setResult(payload); setScanToken(options?.scanToken || null); setStep("cough"); }}
      onBack={() => setStep("language")} />;
  }
  if (step === "facescan") {
    return <FaceScan onlineIdentity scanDuration={30} forceAssessments={{ pulmo: true, cognitive: true }}
      onDone={(payload, options) => { setResult(payload); setScanToken(options?.scanToken || null); setStep("cough"); }}
      onBack={() => setStep("language")} />;
  }
  if (step === "cough") {
    return <Pulmo coughOnly scanToken={scanToken} employee={result?.employee}
      onDone={(payload) => { setPulmoResult(payload); setStep("pvtb"); }} />;
  }
  if (step === "pvtb") return <Pvtb trials={5} age={result?.employee?.age}
    onDone={(payload) => { setPvtResult(payload); setStep("result"); }} />;
  if (step === "result") {
    return <Result siteJourney deferSubmission result={result}
      pulmoResult={pulmoResult} pvtResult={pvtResult} onRestart={restart} />;
  }
  return null;
}